const name = 'userReducer'

export const selectInitialLoading = (state: any) => state[name].initialLoading
export const selectUserInitStatus = (state: any) => state[name].isUserInitFailed
export const selectUserOverviewFetching = (state: any) =>
  state[name].userOverviewFetching
export const selectUserCustomerView = (state: any) =>
  state[name].userCustomerView
export const selectUserSubscriptionView = (state: any) =>
  state[name].userSubscriptionView
export const selectUserBalanceView = (state: any) => state[name].userBalanceView
export const selectUserScrapperView = (state: any) =>
  state[name].userScrapperView
export const selectUserProxyView = (state: any) => state[name].userProxyView
export const selectStatsUrlFetching = (state: any) =>
  state[name].statsUrlFetching
export const selectUserStatsUrl = (state: any) => state[name].userStatsUrl
export const selectUserFirstName = (state: any) => state[name].firstName
export const selectUserLastName = (state: any) => state[name].lastName
export const selectUserEmail = (state: any) => state[name].email
export const selectTempUserFirstName = (state: any) => state[name].tempFirstName
export const selectTempUserLastName = (state: any) => state[name].tempLastName
export const selectScrapperApiKey = (state: any) => state[name].scrapperApiKey
export const selectScrapperApiKeyFetching = (state: any) =>
  state[name].scrapperApiKeyFetching
export const selectProxyPackages = (state: any) => state[name].proxyPackages
export const selectAvailableHosts = (state: any) => state[name].availableHosts
export const selectProxyPackagesFetching = (state: any) =>
  state[name].proxyPackagesFetching
export const selectIntercomUserHash = (state: any) => state[name].intercomHash
export const selectUserHash = (state: any) => state[name].userHash
export const selectEnterpriseStatus = (state: any) =>
  state[name].isEnterpriseActive
export const selectResellerStatus = (state: any) => state[name].isResellerActive
